// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8697f71","732":"703843ea","977":"4fc2af84"}[chunkId] + ".chunk.js";
};